import { PlayerExpandedHeader } from "./PlayerExpandedHeader";
import { PlayerExpandedMobile } from "./PlayerExpandedMobile";
import { PlayerExpandedDesktop } from "./PlayerExpandedDesktop";
import { Track } from "@/types";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/useResponsive";

interface PlayerExpandedViewProps {
  currentTrack: Track;
  isPlaying: boolean;
  liked: boolean;
  sponsorName?: string | null;
  sponsorUsername?: string | null;
  sponsorAvatar?: string | null;
  volume: number;
  currentTime: number;
  audioRef: React.RefObject<HTMLAudioElement>;
  onToggleLike: () => void;
  onTogglePlayPause: () => void;
  onVolumeChange: (value: number[]) => void;
  onSeek: (value: number[]) => void;
  onSeekToTime: (time: number) => void;
  onToggleExpand: () => void;
  formatTime: (timeInSeconds: number) => string;
  setIsPlaying: (playing: boolean) => void;
}

export function PlayerExpandedView({
  currentTrack,
  isPlaying,
  liked,
  sponsorName,
  sponsorUsername,
  sponsorAvatar,
  volume,
  currentTime,
  onToggleLike,
  onTogglePlayPause,
  onVolumeChange,
  onSeek,
  onToggleExpand,
  formatTime,
}: PlayerExpandedViewProps) {
  const isMobile = useIsMobile();

  return (
    <div
      className="h-full flex flex-col"
      onContextMenu={(e) => e.preventDefault()}
    >
      <div
        className={cn("flex flex-col h-full", isMobile ? "p-4" : "p-4 md:p-6")}
      >
        {/* Header */}
        <PlayerExpandedHeader onToggleExpand={onToggleExpand} />

        {/* Mobile-optimized layout */}
        {isMobile ? (
          <PlayerExpandedMobile
            currentTrack={currentTrack}
            isPlaying={isPlaying}
            liked={liked}
            sponsorName={sponsorName}
            sponsorUsername={sponsorUsername}
            sponsorAvatar={sponsorAvatar}
            volume={volume}
            currentTime={currentTime}
            onToggleLike={onToggleLike}
            onTogglePlayPause={onTogglePlayPause}
            onVolumeChange={onVolumeChange}
            onSeek={onSeek}
            formatTime={formatTime}
          />
        ) : (
          // Desktop layout
          <PlayerExpandedDesktop
            currentTrack={currentTrack}
            isPlaying={isPlaying}
            liked={liked}
            sponsorName={sponsorName}
            sponsorUsername={sponsorUsername}
            sponsorAvatar={sponsorAvatar}
            volume={volume}
            currentTime={currentTime}
            onToggleLike={onToggleLike}
            onTogglePlayPause={onTogglePlayPause}
            onVolumeChange={onVolumeChange}
            onSeek={onSeek}
            formatTime={formatTime}
          />
        )}
      </div>
    </div>
  );
}
